<script src="../../main.js"></script>
<template>
    <div>
        <my-table :title="title"
                  :searchParams="searchParams"
                  :isAdd="isAdd"
                  :tableData="tableData"
                  @pageNumChange="pageNumChange"
                  @search="search"
                  @keyup.enter.native="keyup()">
            <div slot="table">
                <reflectRecord-table :tableData="tableData.list" @audit="audit"></reflectRecord-table>
            </div>
        </my-table>
        <el-dialog title="审核" :visible.sync="dialogFormVisible" width="60%">
            <div style="margin-bottom: 80px;">
                <div class="dataShow">
                    <div class="line">
                        <div class="key">提现信息</div>
                        <div class="value">
                            <div>持卡人：{{document.bindUserName}}</div>
                            <div>开户行&网点：{{document.accountOpeningBranch}}</div>
                            <div>银行卡：{{document.documentNumber}}</div>
                        </div>
                    </div>
                    <div class="line">
                        <div class="key">审核状态</div>
                        <div class="value">
                            <el-radio-group @change="changeStatus" v-model="reflectRecord.status" size="small">
                                <el-radio-button label="Approved">审核通过</el-radio-button>
                                <el-radio-button label="ReviewFailed">审核不通过</el-radio-button>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="line">
                        <div class="key">财务转账凭证</div>
                        <div class="value">
                            <div class="upload">
                                <el-upload
                                        :headers="headers"
                                        ref="ReflectTransferAccounts"
                                        :on-progress="progress"
                                        :on-change="upLoad"
                                        :on-success="handleDocumentSuccess"
                                        :limit="1"
                                        class="upload-demo"
                                        name="multipartFile"
                                        :data="uploadParam.ReflectTransferAccounts"
                                        :action="baseURL+'/system/uploadFile'"
                                        :show-file-list="false"
                                        list-type="picture-card"
                                        accept=".jpg,.png,.jpeg">
                                    <img style="width: 100px;height: 100px;"
                                         v-if="reflectRecord.reflectTransferAccountUrl"
                                         :src="reflectRecord.reflectTransferAccountUrl" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    <div slot="tip" class="el-upload__tip">请上传财务转账凭证</div>
                                </el-upload>
                            </div>

                        </div>
                    </div>
                    <div class="line">
                        <div class="key">手续费</div>
                        <div class="value">
                            <el-input class="w500" v-model="reflectRecord.proceduresAmount"
                                      placeholder=" 请填写手续费"></el-input>
                        </div>
                    </div>
                    <div class="line">
                        <div class="key">备注</div>
                        <div class="value">
                            <el-input class="w500" v-model="reflectRecord.remark" placeholder=" 请填写备注"></el-input>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="auditSubmit">审 核</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ReflectRecordTable from "./ReflectRecordTable";
    import MyTable from "../../components/content/myTable/MyTable";
    import {getReflectRecordBySearch, newVue, audit} from "../../network/reflectRecord";

    export default {
        name: "reflectRecordList",
        components: {ReflectRecordTable, MyTable},
        data() {
            return {
                title: "提现记录列表",
                //搜索条件
                searchParams: [
                    {
                        key: "status",
                        value: "审核状态",
                        isSelect: [
                            {
                                key: "未审核",
                                value: "Applied"
                            },
                            {
                                key: "审核通过",
                                value: "Approved"
                            },
                            {
                                key: "审核不通过",
                                value: "ReviewFailed"
                            }
                        ]
                    },
                ],
                isAdd: false,
                tableData: {},
                searchItems: {},
                dialogFormVisible: false,//是否展示对话框
                reflectRecord: {},//记录信息
                headers: {},
                baseURL: newVue.baseURL,
                loadingMsg: null,
                uploadParam: {
                    ReflectTransferAccounts: {type: "ReflectTransferAccounts"},
                },
                document: {}
            }
        },
        created() {
            newVue.obj = this;
            this.common.HeaderLocationTwo.href = "/reflectRecord/list";
            this.common.HeaderLocationTwo.name = "爱助农管理";
            this.common.HeaderLocationThree.name = "提现记录";
            this.authorization = newVue.obj.common.loginInfo.jwtToken;
            this.headers.Authorization = this.authorization;
            getReflectRecordBySearch("", 1, 10).then(res => {
                for (let i = 0; i < res.data.list.length; i++) {
                    res.data.list[i]["statusText"] = this.getStatusText(res.data.list[i].status);
                }
                this.tableData = res.data;
            })
        },
        methods: {
            pageNumChange(pageNum) {
                this.searchEasy(this.searchItems, pageNum);
            },
            search(searchItems) {
                this.searchItems = searchItems;
                this.searchEasy(searchItems)
            },
            searchEasy(searchItems, pageNum) {
                let status = null;
                for (let i = 0; i < searchItems.length; i++) {
                    if (searchItems[i].value === "status") {
                        status = searchItems[i].input
                    }
                }
                getReflectRecordBySearch(status, pageNum, 10).then(res => {
                    for (let i = 0; i < res.data.list.length; i++) {
                        res.data.list[i]["statusText"] = this.getStatusText(res.data.list[i].status);
                    }
                    this.tableData = res.data
                });
            },
            keyup() {
                this.searchEasy(this.searchItems);
            },
            audit(reflectRecord) {
                if (reflectRecord.status != "Applied") {
                    this.$confirm('该记录已审核', '提示', {type: 'warning'})
                    return;
                }
                this.reflectRecord = reflectRecord;
                this.document = reflectRecord.document;
                this.dialogFormVisible = true;
            },
            auditSubmit() {//审核
                let obj = this.reflectRecord;
                if (obj.status == 'Applied') {
                    this.$confirm('请选择审核状态', '提示', {type: 'warning'})
                    return;
                }
                if (obj.status == 'Approved' && (obj.proceduresAmount == null || obj.proceduresAmount == "" || obj.reflectTransferAccount == null)) {
                    this.$confirm('请填写完整审核信息', '提示', {type: 'warning'})
                    return;
                }
                audit(obj).then(res => {
                    this.dialogFormVisible = false;
                    console.log(res);
                    if (res.code == 200) {
                        getReflectRecordBySearch("", 1, 10).then(res => {
                            for (let i = 0; i < res.data.list.length; i++) {
                                res.data.list[i]["statusText"] = this.getStatusText(res.data.list[i].status);
                            }
                            this.tableData = res.data;
                            // this.$forceUpdate();
                        });
                    }

                });

            },
            upLoad(file, fileList) {
                this.$refs.ReflectTransferAccounts.submit();
            },
            progress() {
                this.loadingMsg = this.$loading({
                    lock: true,
                    text: '正在上传中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            },
            handleDocumentSuccess(res, file) {
                let item = {};
                item["name"] = file.name;
                item["id"] = file.uid;
                item["fileSize"] = file.raw.size;
                item["fileType"] = file.raw.type;
                item["associationType"] = file.response.data.associationType;
                item["url"] = file.response.data.url;
                item["imageUrl"] = URL.createObjectURL(file.raw);
                if (file.response != null) {
                    switch (file.response.data.associationType) {
                        case "ReflectTransferAccounts":
                            this.reflectRecord.reflectTransferAccount = item;
                            this.reflectRecord.reflectTransferAccountUrl = item.url;
                            break;
                    }
                }
                if (this.loadingMsg != null) {
                    this.loadingMsg.close();
                }
                this.$forceUpdate();
            },
            getStatusText(status) {
                let text = "";
                switch (status) {
                    case "Applied":
                        text = "未审核";
                        break;
                    case "Approved":
                        text = "审核通过";
                        break;
                    case "ReviewFailed":
                        text = "审核不通过";
                        break;
                }
                return text;
            },
            changeStatus(){
                this.$forceUpdate();
            },
        }
    }
</script>

<style scoped>
    @import "../../assets/css/data.css";

    .upload {
        display: inline-block;
    }
</style>
